'use client';

type ActionIconButtonProps = {
  label: string;
  icon: 'edit' | 'trash';
  tone?: 'neutral' | 'danger';
  onClick: () => void;
};

function ActionIcon({ icon }: { icon: ActionIconButtonProps['icon'] }) {
  if (icon === 'trash') {
    return (
      <svg
        viewBox="0 0 24 24"
        className="h-5 w-5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M3 6h18" />
        <path d="M8 6V4h8v2" />
        <path d="M6 6l1 15h10l1-15" />
        <path d="M10 11v6" />
        <path d="M14 11v6" />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 24 24"
      className="h-5 w-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z" />
    </svg>
  );
}

export default function ActionIconButton({ label, icon, tone = 'neutral', onClick }: ActionIconButtonProps) {
  const toneClass =
    tone === 'danger'
      ? 'border-rose-900/80 bg-rose-950/60 text-rose-200 hover:border-rose-400 hover:bg-rose-900/70'
      : 'border-slate-700 bg-slate-950 text-slate-200 hover:border-brand-400 hover:text-brand-200';

  return (
    <button
      type="button"
      onClick={onClick}
      title={label}
      aria-label={label}
      className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border shadow-none transition focus:border-brand-400 focus:outline-none focus:ring-2 focus:ring-brand-500/30 ${toneClass}`}
    >
      <ActionIcon icon={icon} />
    </button>
  );
}
